import { render } from "./PositionDistribution.vue?vue&type=template&id=19c3814c&scoped=true&ts=true"
import script from "./PositionDistribution.vue?vue&type=script&lang=ts"
export * from "./PositionDistribution.vue?vue&type=script&lang=ts"

import "./PositionDistribution.vue?vue&type=style&index=0&id=19c3814c&scoped=true&lang=less"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19c3814c"]])

export default __exports__